var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { QuiField } from "../QuiField.js";
import { useQuiField } from "../useQuiField.js";
import { QuiTextArea } from "../../../index.js";
export const QuiTextAreaField = forwardRef((_a, ref) => {
    var { name, label, helperText, subHelperText, size, lines, maxLength, maxLines, showCount, placeholder, autoComplete, spellCheck, config, validate } = _a, otherProps = __rest(_a, ["name", "label", "helperText", "subHelperText", "size", "lines", "maxLength", "maxLines", "showCount", "placeholder", "autoComplete", "spellCheck", "config", "validate"]);
    const { inputProps, fieldProps } = useQuiField(name, Object.assign(Object.assign({}, config), { validate }));
    return (React.createElement(QuiField, Object.assign({ label: label, helperText: helperText, subHelperText: subHelperText }, fieldProps, otherProps),
        React.createElement(QuiTextArea, Object.assign({ ref: ref, size: size, lines: lines, showCount: showCount, maxLines: maxLines, autoComplete: autoComplete, spellCheck: spellCheck, maxLength: maxLength, placeholder: placeholder }, inputProps))));
});
QuiTextAreaField.displayName = "QuiTextAreaField";
